import React, { useContext, useEffect, useState } from "react"
import { ExchangeProps, ExchangeAndTransfersProps } from "./types"
import {  Button, Checkbox, CheckboxProps, Col, message, Form, Input, InputNumber, Modal, notification, Row, Select } from "antd"
import { useGetAllClients } from "../../../Services/useGetAllClients"
import { useGetCurrency } from "../../../Services/useGetCurrency"
import { useGetCashDesk } from "../../../Services/useGetCashDesk"
import ModalTitle from "../../ModalTitle"
import { VariablesContext } from "../../../Contexts/UserContext/VariablesContext"
import { Transaction } from "../../../Services/useGetMovements"
import { OperationsContext } from "../../../Contexts/UserContext/OperationsContext"
import { OperationTypeProps, useOperations } from "../../../Services/useOperations"
import CheckoutTables from "../PucrchaseSaleCurrenciesForm/CheckoutTables"
import { ListCheckout } from "../PucrchaseSaleCurrenciesForm/types"
import NewCustomer from "../../NewCustomer"
import { useForm } from "antd/es/form/Form"

const Exchange: React.FC<ExchangeProps> = ({
    form,
    FIN,
    placeholder,
    main_currency,
    initialValue,
    disabledForm,
    setFirstListCheckout,
    setSecondListCheckout,
    form_list_checkouts,
    form_list_checkouts_second
})=>{

    const [result, setResult] = useState<number | undefined>()
    const { data: clients} = useGetAllClients()  
    const { data: currencies} = useGetCurrency()  
    const { Option } = Select;   

    const mandatory = [
        {
            required: true,
            message:'Este campo es obligatorio'
        }
    ]  

    const selectedCurrency = Form.useWatch(FIN.currency, form);
    const mainCurrency = Form.useWatch('main_currency_id', form);
    const debit = Form.useWatch('debit', form);
    //const selectedCustomer = Form.useWatch(FIN.customers, form);
    
    const selectedRate = Form.useWatch(FIN.rate, form);
    const selectedRateUsdt = Form.useWatch(FIN.rate_usdt, form);
    //const selectedBranch= Form.useWatch(FIN.branch, form);   

    useEffect(() => {
        if (!debit) return;      

        switch (true) {
            case selectedCurrency === 3 && !!selectedRateUsdt && !!selectedRate: //USDT 
                setResult(debit / selectedRate / ((selectedRateUsdt / 100) + 1));
            break;
            default:
                if(!!mainCurrency && !!selectedCurrency && !!selectedRate)
                setResult(debit / selectedRate);
            break;
        }
    }, [selectedRate, debit, selectedRateUsdt, mainCurrency, selectedCurrency]);

    useEffect(()=>{
        if((mainCurrency == 2 && selectedCurrency == 3) || (mainCurrency == 3 && selectedCurrency == 2)) {
            form.resetFields([FIN.rate]); 
        }else if(mainCurrency !== 3 && selectedCurrency !== 3){
            form.resetFields([FIN.rate_usdt]); 
        }
    },[mainCurrency, selectedCurrency])

    const changePoint = (e:  React.KeyboardEvent<HTMLInputElement>)=>{
        const input = e.currentTarget as HTMLInputElement;
        const start = input.selectionStart ?? 0;
        const end = input.selectionEnd ?? 0;
        let newValue = input.value

        if (e.key === '.' && !e.shiftKey) {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }else if (e.key === ',') {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    }

    return(
        <>
            <Row
                justify='space-between'
            >
                <Col
                    span={11}
                >
                    <Form.Item
                        name={FIN.customers}
                        rules={mandatory} 
                        label='Cliente'
                        style={{marginBottom: 10}}
                    >
                        <Select
                            showSearch  
                            loading={!clients }
                            placeholder={!clients ? 'Cargando...' : 'Cliente'}
                            disabled={disabledForm?.disable}   
                            filterOption={(input, option) =>
                                (option?.children?.toString().toLowerCase() || '').includes(input.toLowerCase())
                            }    
                        >
                            {   clients &&
                                clients.map((item)=>
                                    <Option value={item.id} key={item.id}>
                                        {item.first_name + item.last_name}
                                    </Option>
                                )
                            }
                        </Select>
                    </Form.Item>
                </Col>
                <Col
                    span={11}
                >                
                    <Form.Item
                        name={FIN.currency}
                        // rules={mandatory}
                        label={placeholder.currency}
                        style={{marginBottom: 10}}
                    >             
                        <Select          
                            loading={!currencies}
                            placeholder={placeholder.currency}                       
                            style={{
                                minWidth: 105,
                                marginBottom: 8
                            }}
                            disabled={disabledForm?.disable}   
                            allowClear   
                            onChange={(value) => {
                                if(placeholder.currency === 'Moneda Venta'){
                                    setFirstListCheckout([])   
                                    form_list_checkouts.resetFields()  
                                }else if(placeholder.currency === 'Moneda Compra'){
                                    setSecondListCheckout([])
                                    form_list_checkouts_second.resetFields()  
                                }
                                form.resetFields([FIN.rate])  
                            }}             
                        >
                            {currencies && currencies && currencies.filter((x)=> x.id !== main_currency)
                                .map((item) => (
                                    <Option value={item.id} key={item.id}>
                                        {item.name}
                                    </Option>
                            ))} 
                        </Select>
                    </Form.Item>
                </Col>
            </Row>           
            <Row
                justify='space-between'
            >
                <Col
                    span={11}
                >
                      { ((mainCurrency == 2 && selectedCurrency == 3) || (mainCurrency == 3 && selectedCurrency == 2)) 
                       ?<></>
                       :<Form.Item
                            name={FIN.rate}
                            rules={selectedCurrency ? mandatory : undefined}
                            style={{marginBottom: 15}}
                        >                                     
                            <InputNumber
                                disabled={disabledForm.disable || disabledForm.approved}  
                                //style={{width: '100%'}}
                                placeholder="Tipo de cambio"
                                addonBefore={
                                    currencies && main_currency && main_currency !==3 
                                    ? currencies.find((x)=>x.id == main_currency)?.sign
                                    : main_currency && main_currency == 3 && selectedCurrency
                                        ? currencies.find((x)=>x.id == selectedCurrency)?.sign
                                        : ' ¤ ' }
                                formatter={value =>
                                    value
                                        ? new Intl.NumberFormat('es-AR', {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 20
                                        }).format(Number(value))
                                        : ''
                                }
                                onKeyDown={changePoint}
                                parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                                stringMode 
                        />                        
                        </Form.Item>}
                </Col>
                <Col 
                    span={11}
                >
                    {((mainCurrency && mainCurrency == 3) || (selectedCurrency && selectedCurrency == 3)) &&
                        <Form.Item
                            name={FIN.rate_usdt}
                            rules={mandatory}
                            style={{width: '218px', marginBottom: 20}}
                        >                           
                            <InputNumber
                                disabled={disabledForm.disable || disabledForm.approved}  
                                style={{width: '100%'}}
                                placeholder="Conversión USD a "
                                addonBefore={'%'}
                                formatter={value =>
                                    value
                                        ? new Intl.NumberFormat('es-AR', {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 20
                                        }).format(Number(value))
                                        : ''
                                    }
                                onKeyDown={changePoint}
                                parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                                stringMode 
                            />                                                            
                        </Form.Item>
                    }  
                </Col>
            </Row>   
            <span
                style={{
                    paddingLeft: 5,
                }}
            ><strong>Resultado: </strong>
                {selectedCurrency && result && !isNaN(result) && currencies.find(x => x.id === selectedCurrency)?.sign}
                {' '}
                {result && !isNaN(result) && result.toLocaleString('es-AR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}</span>                      
        </>        
    )
}

export const ExchangeAndTrasnfers: React.FC<ExchangeAndTransfersProps>=({
    form
})=>{

    const { data: currencies } = useGetCurrency() 
    const { data: clients } = useGetAllClients()  
    const { createOperation, editOperation } = useOperations()   
    const { confirmOperation } = useOperations()
    const { data: checkouts } = useGetCashDesk()
    const { Option } = Select
    const {
        collapsedFilsters, 
        setCollapsedFilters, 
        setShowForms, 
        showForms, 
        dataTransactionsToForm: transactions,
        setDataTransactionsToForm
    } = useContext(VariablesContext) 
    const {setRowSelect} = useContext(OperationsContext) 

    const [loadingBtn, setLoadingBtn] = useState(false)
    const [aproved, setAproved] = useState(false) 
    const [firstListCheckout, setFirstListCheckout] = useState<ListCheckout[]>([])
    const [secondListCheckout, setSecondListCheckout] = useState<ListCheckout[]>([]) 
    const [edit, setEdit] = useState<boolean>(false)
    const [form_list_checkouts] = useForm()
    const [form_list_checkouts_second] = useForm()
    const [messageApi, contextHolder] = message.useMessage();

    const [disabledForm, setDisableForm] = useState<{
        disable: boolean,
        approved: boolean,
        deleted: boolean,
        operationNumber: number | undefined,
        isEditable: boolean,
    }>({
        disable: true,
        approved: false,
        deleted: false,
        operationNumber: undefined,
        isEditable: false
    })

    const mandatory = [
        {
            required: true,
            message:'Este campo es obligatorio'
        }
    ]  

    const mainCurrency = Form.useWatch('main_currency_id', form);
    const secondaryCurrencyId = Form.useWatch('transmitter_secondary_currency_id', form);
    const supplierSecondaryCurrencyId = Form.useWatch('receiver_secondary_currency_id', form); 

    useEffect(()=>{ 
        if(transactions){
            uploadData(transactions)
        }else{            
            setDisableForm({
                disable: false,
                approved: false,
                deleted: false,
                operationNumber: undefined,
                isEditable: false
            })
            form.resetFields()
            form.setFieldsValue({main_currency_id: 1})
        }    
    },[])    

    const uploadData =  async(transactions: Transaction) =>{
        let approvedOperations = transactions.related_load_operations.some((x)=> x.approved)
        let firstDetais = transactions.related_load_operations.find((x)=>x.currency_sale || x.usdt_sale)?.origin_operation_details 
        let secondDetails = transactions.related_load_operations.find((x)=>!x.currency_sale || !x.usdt_sale)?.destination_operation_details

        let originCheckoutDetails = transactions.origin_operation_details
        let destinationCheckotDetails = transactions.destination_operation_details

        setAproved(transactions.approved)
        setDisableForm({
            disable: transactions.approved || approvedOperations,
            isEditable: approvedOperations && !transactions.approved,
            approved: transactions.approved,
            deleted: transactions.deleted,
            operationNumber: transactions.operation_id
        })

        if (firstDetais && originCheckoutDetails) {
            messageApi.info('Error en la visualización de cajas. Contacte al administrador.');
        }else if(firstDetais && firstDetais.length > 0){
            setFirstListCheckout(mapCheckoutDetails(firstDetais, 'debit'));
        }else if(originCheckoutDetails){
            setFirstListCheckout(mapCheckoutDetails(originCheckoutDetails, 'debit'));
        }  
        
        if (firstDetais && destinationCheckotDetails) {
            messageApi.info('Error en la visualización de cajas. Contacte al administrador.');
        }else if (secondDetails &&  secondDetails.length > 0) {
            setSecondListCheckout(mapCheckoutDetails(secondDetails, 'credit'));
        }else if(destinationCheckotDetails){
            setSecondListCheckout(mapCheckoutDetails(destinationCheckotDetails, 'credit'));
        }    
        
        form.setFieldsValue(
            { 
                main_currency_id: 1, //pesos por defecto
                receiver_secondary_currency_id: transactions.receiver_secondary_currency_id,
                debit: transactions.debit, 
                receiver_usdt_quote_percentage: transactions.receiver_usdt_quote_percentage,
                transmitter_usdt_quote_percentage: transactions.transmitter_usdt_quote_percentage,
                receiver_id: transactions.receiver_id,
                transmitter_id: transactions.transmitter_id,
                receiver_currency_quote: transactions.receiver_currency_quote,
                transmitter_currency_quote: transactions.transmitter_currency_quote,
                transmitter_secondary_currency_id: transactions.transmitter_secondary_currency_id,                    
                description: transactions.description
            }
        )               
        
    }

    const mapCheckoutDetails = (details: any[], amountKey: 'debit' | 'credit'): ListCheckout[] =>
        details?.map(x => ({
            name: x.checkout?.name || '',
            id: x.checkout?.id,
            sign: x.checkout?.currency?.sign || '',
            amount: x[amountKey],
            branch_name: x.checkout?.branch?.name || ''
        }
    ));

    const handleCancel =()=>{
        setShowForms(Object.fromEntries(Object.keys(showForms).map(key => [key, false])))// pone todos en false
        setLoadingBtn(false)
        form.resetFields()
        setDataTransactionsToForm(undefined) 
        setRowSelect(undefined)
        setEdit(false)
    }

    const onChangeAmountTransfer = () =>{        
    }    

    const onChangeAproved: CheckboxProps['onChange'] = async (e) => {
        setAproved(e.target.checked); 
    };

    const confirmSave = async(operationData: OperationTypeProps) =>{
        let response
        transactions
            ? response = await editOperation(handleCancel, transactions.id.toString(), operationData)
            : response = await createOperation(handleCancel, operationData);
        if(response == 'error'){
            setLoadingBtn(false)
        }else{
            setCollapsedFilters(!collapsedFilsters)  
        }                       
    }       

    const handleSave = (e: {
        description: string,
        main_currency_id: number,
        receiver_secondary_currency_id: number,
        transmitter_secondary_currency_id: number,
        debit: number,
        receiver_usdt_quote_percentage: number | undefined,
        transmitter_usdt_quote_percentage: number | undefined,
        receiver_id: number,
        transmitter_id: number,
        receiver_currency_quote: number | undefined,
        transmitter_currency_quote: number | undefined,
    }) =>{
        console.log(e)

        const firstList = (action: string)=> firstListCheckout.map(({ id, amount }) => ({
            checkout_id: id,
            [action]: amount
        }));        

        const secondList =  (action: string)=> secondListCheckout.map(({ id, amount }) => ({
            checkout_id: id,
            [action]: amount
        })); 

        let origin_checkout =  firstList('debit') 
        let destination_checkout =  secondList('credit')  
        
        const finalData = {
            ...e,
            type_id: 17,
            approved: aproved,
            ...(origin_checkout?.length > 0 ? { origin_operation_details: origin_checkout } : {}),
            ...(destination_checkout?.length > 0 ? { destination_operation_details: destination_checkout } : {}),
        };
                    
        Modal.confirm({
            width: 530,
            title: 'Confirmar operación',
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            onOk:()=>confirmSave(finalData),
            content: (
                <div >
                     {e.debit && e.main_currency_id && <p><strong>Monto transferencia: </strong>{currencies.find((x)=>x.id == e.main_currency_id)?.sign + ' ' + Number(e.debit).toLocaleString('es-AR', {minimumFractionDigits:2, maximumFractionDigits:2})}</p>}
                    <Row
                        justify={'space-between'}
                    >                        
                        <Col span={12} >                           
                            <p style={{color: 'rgb(48, 203, 133)', fontWeight: 700}}>Emisor de trasnferencia</p>
                                {e.transmitter_id && <p><strong>Cliente: </strong> {clients?.find((x)=>x.id === e.transmitter_id)?.first_name + ' ' +  clients?.find((x)=>x.id === e.transmitter_id)?.last_name}</p>}
                                {e.transmitter_secondary_currency_id && <p><strong>Moneda Venta: </strong>{currencies.find((x)=> x.id === e.transmitter_secondary_currency_id)?.sign}</p>}
                                {e.receiver_currency_quote && <p><strong>Tipo de cambio </strong>
                                    {   e.main_currency_id !==3 
                                            ? currencies.find((x)=>x.id == e.main_currency_id)?.sign
                                            : e.main_currency_id == 3 && e.transmitter_secondary_currency_id
                                                ? currencies.find((x)=>x.id == e.transmitter_secondary_currency_id)?.sign
                                                : ' ¤ '
                                    } 
                                    {' '}
                                    {Number(e.transmitter_currency_quote)?.toLocaleString('es-AR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                    </p>
                                }      
                                {e.transmitter_usdt_quote_percentage &&<p><strong>% USDT: </strong>{e.transmitter_usdt_quote_percentage} %</p>}  

                           
                        </Col>
                        <Col span={12} >
                            <p style={{color: '#37bde0', fontWeight: 700}}>Receptor de trasnferencia</p>  
                            {e.receiver_id && <p><strong>Cliente: </strong> {clients?.find((x)=>x.id === e.receiver_id)?.first_name + ' ' +  clients?.find((x)=>x.id === e.receiver_id)?.last_name}</p>}
                                {e.receiver_secondary_currency_id && <p><strong>Moneda Compra: </strong>{currencies.find((x)=> x.id === e.receiver_secondary_currency_id)?.sign}</p>}
                                {e.receiver_currency_quote && <p><strong>Tipo de cambio </strong>
                                    {   e.main_currency_id !==3 
                                            ? currencies.find((x)=>x.id == e.main_currency_id)?.sign
                                            : e.main_currency_id == 3 && e.receiver_secondary_currency_id
                                                ? currencies.find((x)=>x.id == e.receiver_secondary_currency_id)?.sign
                                                : ' ¤ '
                                    } 
                                    {' '}
                                    {Number(e.receiver_currency_quote).toLocaleString('es-AR',{minimumFractionDigits: 2, maximumFractionDigits:2})}
                                    </p>
                                } 
                                {e.receiver_usdt_quote_percentage &&<p><strong>% USDT: </strong>{e.receiver_usdt_quote_percentage} %</p>}
                          
                        </Col> 
                    </Row>                                                    
                    <Row
                        justify={'space-between'}
                        style={{
                            borderTop: '1px solid gray',
                            padding: '8px 0px',
                        }}
                    >
                        <Col 
                            span={12} 
                            style={{ 
                                flexDirection:'column',
                                display: 'flex',
                                justifyContent: 'flex-start',
                                //alignItems:'start'
                            }}
                        >
                            {renderCheckoutSection('Extracción en cajas', firstListCheckout)}
                        </Col>
                        <Col 
                            span={12} 
                            style={{ 
                                flexDirection:'column',
                                display: 'flex',
                                justifyContent: 'flex-start',
                                //alignItems:'start'
                                
                            }}>
                            {renderCheckoutSection('Depósit en cajas', secondListCheckout)}
                        </Col>
                    </Row>     
                    <Row
                        style={{
                            borderTop: '1px solid gray'
                        }}
                    >
                        <Col  span={12}>
                            <p style={{margin: 5}}><strong>Total: </strong>{firstListCheckout?.[0]?.sign}  {formatAmount(firstListCheckout?.reduce((sum, { amount }) => sum + Number(amount), 0))}</p>
                        </Col>
                        <Col span={12}>
                            <p style={{margin: 5}}><strong>Total: </strong>{secondListCheckout?.[0]?.sign}  {formatAmount(secondListCheckout?.reduce((sum, { amount }) => sum + Number(amount), 0))}</p>
                        </Col>
                    </Row> 
                    <p>
                        <strong>Estado: </strong>
                        <strong style={{ color: aproved ? 'green' : 'orange' }}>
                            {aproved ? 'Aprobado' : 'Sin aprobar'}
                        </strong>
                        </p>                                                                                               
                </div>
            ),
        });                 
    }

    const formatAmount = (value: number) => 
        Number(value).toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    
    const renderCheckoutSection = (title: string, list: typeof firstListCheckout) => {
        return  (
            <>
                <p style={{ margin: 3}}><strong>{title}:</strong></p>
                {list.length > 0 && list?.map(({ name, sign, amount }, index) => (
                    <p style={{fontSize: 12, margin: 3}} key={index}><strong>{name}: </strong> {sign} {formatAmount(Number(amount))}</p>
                ))}               
            </>
        );
    }

    const handleEdit = () =>{
        if(edit){
            setEdit(false)
            setDisableForm(prev=>({...prev, disable: true}))
        }else{
            Modal.confirm({            
            width: 530,
            title: 'Advertencia',
            okText: 'Entendido',
            cancelText: 'Cancelar',
            onOk:()=>{
                setEdit(true)
                setDisableForm(prev=>({...prev, disable: false}))
            },
            onCancel:()=>{
                setEdit(false)
            },
            content:(
                <Row>
                    <p>
                        Si usted edita el formulario, todas las operaciónes relacionadas se editarán. 
                        Si hay una operación aprobada, se hará el reverso de esa operación para luego crearla nuevamente
                    </p>
                </Row>
            )
        })
        }        
    }
    
    const handleApprove = () =>{
        if(transactions){
            transactions.related_load_operations.map((item)=>{
                if(!item.approved){
                  confirmOperation(item.id, handleCancel)  
                }  
            })
            if(!transactions.approved){
                confirmOperation(transactions.id, handleCancel) 
            }
        }
    }

    const handleConfirmApproved = () =>{
         Modal.confirm({
            width: 530,
            title: 'Aprobar operaciones',
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            onOk:()=>handleApprove(),
            content:(
                <Row>
                    ¿Está seguro que desea aprobar todas las operaciones?
                </Row>
            )
        })
    }

    const changePoint = (e:  React.KeyboardEvent<HTMLInputElement>)=>{
        const input = e.currentTarget as HTMLInputElement;
        const start = input.selectionStart ?? 0;
        const end = input.selectionEnd ?? 0;
        let newValue = input.value

        if (e.key === '.' && !e.shiftKey) {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }else if (e.key === ',') {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    }

    return(
        <Modal
            style={{top: 10}}
            width={1100}
            title= {
                <ModalTitle 
                    title={'Compra / venta con transferencia entre terceros'} 
                    isApproved={disabledForm.approved ? true : false}
                    isDeleted={disabledForm.deleted ? true : false}
                    operationNumber={(disabledForm.disable && disabledForm.operationNumber) ? disabledForm.operationNumber : undefined}
                />
            }
            open= {showForms.exchange_trasnfer}
            onCancel={handleCancel}
            okText="Guardar"
            cancelText="Cancelar" 
            onOk={()=>form.submit()}
            footer={
                    disabledForm.approved 
                        ? null 
                        : disabledForm.isEditable 
                         ? [    
                            <Button key= 'approve' onClick={handleConfirmApproved}>Aprobar todo</Button>,                 
                            <Button key="cancel" onClick={handleCancel}>Cancelar</Button>,
                            <Button key="edit" type="primary" onClick={handleEdit}>{edit ? 'Cancelar edición' : 'Editar'}</Button>,
                            <Button key="submit" type="primary" disabled={!edit} onClick={() => form.submit()}>Guardar</Button>
                           ]
                         :  [                        
                            <Button key="cancel" onClick={handleCancel}>Cancelar</Button>,
                            <Button key="submit" type="primary" onClick={() => form.submit()}>Guardar</Button>
                           ]
                }
        >
            {contextHolder}
            <NewCustomer justify="end" positions="leftTop"/>
            <Form
                form={form}
                id='form_exchange_transfer'
                onFinish={handleSave}
                layout="vertical" 
            >
                <Row
                    style={{
                        display:'flex',
                        flexDirection: 'row',
                        marginTop: '20px'
                    }}
                >
                    <Col>
                        <Form.Item>
                            <Form.Item
                                name='main_currency_id'
                                rules={mandatory}
                                label='Moneda de trasnferencia'
                                style={{marginBottom: 5}}
                            >             
                                <Select         
                                    loading={!currencies}
                                    placeholder='Seleccionar moneda'                                                        
                                    disabled={true}                   
                                >
                                    {currencies && currencies && currencies.map((item) => (
                                        <Option value={item.id} key={item.id}>
                                            {item.name}
                                        </Option>
                                    ))} 
                                </Select>
                            </Form.Item>
                        </Form.Item>
                    </Col>
                    <Col style={{marginLeft: '10px'}}>
                         <Form.Item
                            label= 'Monto'
                            name='debit'
                            rules={mandatory}
                            style={{marginBottom: 5}}
                        >                
                            <InputNumber
                                disabled={disabledForm.disable || disabledForm.approved}  
                                style={{width: '100%'}}
                                placeholder="Monto"
                                onChange={onChangeAmountTransfer}
                                addonBefore={mainCurrency && currencies ? currencies.find((x)=>x.id == mainCurrency)?.sign : ' ¤ ' }
                                formatter={value =>
                                value
                                    ? new Intl.NumberFormat('es-AR', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 20
                                    }).format(Number(value))
                                    : ''
                                }
                                onKeyDown={changePoint}
                                parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                                stringMode 
                            />
                        </Form.Item>
                    </Col>
                </Row> 
                <Row
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                >
                    {
                        [1, 2].map((n)=>(
                            <Col
                                style={{
                                    width: '500px',
                                    backgroundColor: 'rgb(241, 241, 241)',
                                    padding: '10px',
                                    //borderRadius: '4px',
                                }}
                            >
                                <Row
                                    justify='space-between'
                                >
                                    <Col>
                                        <p style={{
                                            margin: '0px 5px 10px', 
                                            fontWeight: 500,
                                            color: n === 1 ? 'rgb(48, 203, 133)' : '#37bde0'   
                                        }}>{n === 1 ? 'Cliente emisor de transferencia' : 'Cliente receptor'}</p>
                                    </Col>
                                    <Col>
                                        {n === 1 && transactions?.related_load_operations.find((x)=>!x.currency_sale || !x.usdt_sale)?.approved &&
                                            <span
                                                style={{
                                                    backgroundColor: 'rgb(48, 203, 133)',
                                                    color: 'white',
                                                    padding: '5px 7px',
                                                    borderRadius: 4    
                                                }}
                                            >Aprobada</span>
                                        }
                                        {n === 2 && transactions?.related_load_operations.find((x)=>x.currency_sale || x.usdt_sale)?.approved &&
                                            <span
                                                style={{
                                                    backgroundColor: 'rgb(48, 203, 133)',
                                                    color: 'white',
                                                    padding: '5px 7px',
                                                    borderRadius: 4    
                                                }}
                                            >Aprobada</span>
                                        }
                                    </Col>
                                </Row>
                               
                                <Exchange
                                    form ={form}
                                    FIN = {{
                                        customers: n == 1 ? 'transmitter_id' : 'receiver_id',
                                        currency: n == 1 ? 'transmitter_secondary_currency_id' : 'receiver_secondary_currency_id',
                                        rate: n == 1 ? 'transmitter_currency_quote' : 'receiver_currency_quote',
                                        rate_usdt: n == 1 ? 'transmitter_usdt_quote_percentage' : 'receiver_usdt_quote_percentage',
                                        branch: `${n}_branch`,
                                        checkout: `${n}_checkout`,
                                    }} //form item name
                                    placeholder = {{
                                        currency: n == 1 ? 'Moneda Venta': 'Moneda Compra',   
                                        checkout: 'Caja',
                                        amount: n == 1 ? 'Monto Venta': 'Monto Compra', 
                                    }}   
                                    main_currency={mainCurrency}
                                    initialValue={''}
                                    disabledForm= {disabledForm }
                                    setFirstListCheckout={setFirstListCheckout}
                                    setSecondListCheckout={setSecondListCheckout}
                                    form_list_checkouts={form_list_checkouts}
                                    form_list_checkouts_second={form_list_checkouts_second}
                                />
                            </Col>
                        ))
                    }
                </Row>  
                <Row
                    style={{
                        justifyContent: 'space-between',                    
                    }}
                >
                    {
                        [1, 2].map((n)=>(
                            <Col 
                                style={{
                                    backgroundColor: 'rgb(241, 241, 241)',
                                    padding: '0px 10px 5px',
                                    width: '500px',
                                }}
                            >
                                <p 
                                    style={{
                                        marginLeft: 5
                                    }}
                                >
                                    {n === 1 ? 'Extracción en Caja' : 'Depósito en Caja'}
                                </p>
                                <CheckoutTables
                                    listCheckout={n == 1 ? firstListCheckout : secondListCheckout} 
                                    setListCheckout={n == 1 ? setFirstListCheckout : setSecondListCheckout}
                                    checked={true}
                                    transactionsData={transactions}
                                    listCahs={n == 1 
                                        ? checkouts.filter((x)=> {
                                            if(secondaryCurrencyId ){
                                                if(x.currency.id === secondaryCurrencyId){
                                                   return x 
                                                }                                                
                                            }else if(x.currency.id === 1 ){
                                                return x
                                            }
                                        }) 
                                        : checkouts.filter((x)=>{
                                            if(supplierSecondaryCurrencyId ){
                                                if(x.currency.id === supplierSecondaryCurrencyId){
                                                   return x 
                                                }                                                
                                            }else if(x.currency.id === 1 ){
                                                return x
                                            }
                                        })}                                    
                                    form_list_checkouts={n == 1 ? form_list_checkouts :form_list_checkouts_second}
                                    disabledForm={disabledForm}
                                /> 
                            </Col>                             
                        ))                                        
                    }                    
                </Row> 
                <Checkbox
                    disabled={disabledForm.disable || disabledForm.approved}
                    checked={aproved}
                    onChange={onChangeAproved}
                    style={{marginBottom:10, marginTop: 20}}
                >
                    Aprobado - (Se aprobaran todas las operaciones)
                </Checkbox>  
                <Form.Item
                    label='Descripción'
                    name='description'
                    style={{marginTop: 10}}
                >
                    <Input
                        disabled={disabledForm.disable || disabledForm.approved }
                        placeholder="Comentario"
                    />
                </Form.Item>                                                                              
            </Form>
        </Modal>
    )
}